// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"482":"38321330","841":"c5bc41ae"}[chunkId] + ".chunk.css";
};